module.exports = __webpack_public_path__ + "img/slide-1.a3ace37e.jpg";